import { useEffect, useState } from 'react';

/**
 * The first defined value, kept for the life of the component. The workbook item an
 * exercise starts with ("pick for me" = the first one not used yet) is derived live from the
 * sessions, so a refresh mid-exercise — coming back from the photo gallery, a save landing —
 * could swap the prompt under the person's page (QA note 6). Pinning it here means what
 * they started with is what they finish and what the attempt records.
 */
export function usePinned<T>(value: T | undefined): T | undefined {
  const [pinned, setPinned] = useState(value);
  useEffect(() => {
    if (pinned === undefined && value !== undefined) setPinned(value);
  }, [pinned, value]);
  return pinned;
}
